import React from 'react'

export interface GridProps {
  wrapperStyles?: string
  children: React.ReactNode
}

const Grid = ({ wrapperStyles, children }: GridProps) => {
  return <div className={`grid ${wrapperStyles}`}>{children}</div>
}

export default Grid
